(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-check-availability"] && !Shopify.designMode) return;
  try {
    (function () {

  /* ─── Parse the pincodes setting into a list of numbers + ranges ─── */
  function parsePincodeList(raw) {
    if (!raw) return { singles: new Set(), ranges: [] };
    var singles = new Set();
    var ranges = [];
    var tokens = raw.split(/[\s,]+/).filter(Boolean);

    tokens.forEach(function (token) {
      if (token.indexOf('-') !== -1) {
        var parts = token.split('-');
        var from = parseInt(parts[0], 10);
        var to   = parseInt(parts[1], 10);
        if (!isNaN(from) && !isNaN(to)) {
          if (from > to) { var tmp = from; from = to; to = tmp; }
          ranges.push([from, to]);
        }
      } else {
        var num = parseInt(token, 10);
        if (!isNaN(num)) singles.add(num);
      }
    });

    return { singles: singles, ranges: ranges };
  }

  /* ─── Check a pincode against the parsed list ─── */
  function isServiceable(pincode, parsed) {
    var pin = parseInt(pincode, 10);
    if (isNaN(pin)) return false;
    if (parsed.singles.has(pin)) return true;
    for (var i = 0; i < parsed.ranges.length; i++) {
      if (pin >= parsed.ranges[i][0] && pin <= parsed.ranges[i][1]) return true;
    }
    return false;
  }

  /* ─── Format an ETA given a number of days from today ─── */
  function formatEta(days) {
    var d = new Date();
    d.setDate(d.getDate() + (parseInt(days, 10) || 4));
    return 'By ' + d.toLocaleDateString('en-IN', {
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    });
  }

  /* ─── Main init ─── */
  function initBlock(root) {
    var input   = root.querySelector('.check-availability__input');
    var btn     = root.querySelector('.check-availability__btn');
    var btnText = root.querySelector('.check-availability__btn-text');
    var spinner = root.querySelector('.check-availability__spinner');
    var result  = root.querySelector('.check-availability__result');
    var icon    = root.querySelector('.check-availability__result-icon');
    var city    = root.querySelector('.check-availability__city');
    var eta     = root.querySelector('.check-availability__eta');

    var parsed     = parsePincodeList(root.dataset.pincodes || '');
    var etaDays    = root.dataset.etaDays || 4;
    var cityLabel  = root.dataset.cityLabel || 'your area';

    function setLoading(loading) {
      btn.disabled = loading;
      btnText.style.display  = loading ? 'none' : '';
      spinner.style.display  = loading ? '' : 'none';
    }

    function showResult(data) {
      result.style.display = '';
      if (data.available) {
        root.dataset.state = 'success';
        icon.textContent   = '';
        city.textContent   = data.city || '';
        eta.textContent    = data.eta  || '';
      } else {
        root.dataset.state = 'error';
        icon.textContent   = '❌';
        city.textContent   = 'Sorry, delivery not available to this pincode.';
        eta.textContent    = '';
      }
    }

    function handleCheck() {
      var pincode = input.value.trim();
      if (!/^\d{6}$/.test(pincode)) {
        input.focus();
        input.style.outline = '2px solid #c0392b';
        setTimeout(function () { input.style.outline = ''; }, 1500);
        return;
      }

      setLoading(true);
      result.style.display = 'none';

      // Small artificial delay so the spinner feels responsive (not instant flash)
      setTimeout(function () {
        try {
          var available = isServiceable(pincode, parsed);
          if (available) {
            showResult({
              available: true,
              city: 'Delivers to ' + cityLabel + ' (' + pincode + ')',
              eta: formatEta(etaDays)
            });
          } else {
            showResult({ available: false });
          }
        } catch (err) {
          showResult({ available: false });
          console.error('[check-availability]', err);
        } finally {
          setLoading(false);
        }
      }, 300);
    }

    btn.addEventListener('click', handleCheck);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') handleCheck(); });
  }

  document.querySelectorAll('.check-availability').forEach(initBlock);
  document.addEventListener('shopify:block:load', function (e) {
    if (e.target.classList.contains('check-availability')) initBlock(e.target);
  });

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-coupons"] && !Shopify.designMode) return;
  try {
    (function () {
    function initCoupons(root) {
      root.querySelectorAll('.product-coupons__code-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.dataset.copied === 'true') return;

          var code      = btn.dataset.couponCode;
          var iconCopy  = btn.querySelector('.icon-copy');
          var iconCheck = btn.querySelector('.icon-check');

          navigator.clipboard.writeText(code).then(function () {
            btn.dataset.copied = 'true';
            if (iconCopy)  iconCopy.style.display  = 'none';
            if (iconCheck) iconCheck.style.display = 'block';

            setTimeout(function () {
              btn.dataset.copied = 'false';
              if (iconCopy)  iconCopy.style.display  = '';
              if (iconCheck) iconCheck.style.display = 'none';
            }, 2000);
          }).catch(function () {
            /* Fallback for older browsers */
            var ta = document.createElement('textarea');
            ta.value = code;
            ta.style.position = 'fixed';
            ta.style.opacity  = '0';
            document.body.appendChild(ta);
            ta.focus();
            ta.select();
            try { document.execCommand('copy'); } catch (_) {}
            document.body.removeChild(ta);
          });
        });
      });
    }

    document.querySelectorAll('.product-coupons').forEach(initCoupons);

    document.addEventListener('shopify:block:load', function (e) {
      if (e.target.classList.contains('product-coupons')) initCoupons(e.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
